import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private dataService: DataService) { }

  getIpAddress() {
    return this.dataService.getRecord('/api/GetIpAddress');
  }

  // getUserIpAddress() {
  //   return $.ajax({
  //     type: 'GET',

  //     url: environment.ipAddressUtilityServiceAddress //'http://freegeoip.net/json/' //'http://ipv4.myexternalip.com/json'
  //   });
  // };

  // getHasVersionChanged(clientVersion) {
  //   return this.dataService.makeGETRequestWithoutLoading('/api/hasVersionChanged?clientVersion=' + clientVersion);
  // };
}
